import {View,Model} from 'backbone';
import SimpleConfirmModalView from "common-views/SimpleConfirmModalView.js";
import constants from 'Constants.js';
import eventBus from 'EventBus.js';
import ActionGeneralView from 'dashboard/connections/action-type/ActionGeneralView';
import PermissionsView from '../../settings/PermissionsView';
import contentTemplate from 'dashboard/connections/action-details-view.ejs';
import DetailViewFactory from 'dashboard/connections/DetailViewFactory';
import ActionOperationsView from 'dashboard/connections/action-type/ActionOperationsView';
import ActionService from 'dashboard/connections/action-type/ActionService';
import ConnectionHelpView from 'dashboard/connections/ConnectionsHelpView';
import NotificationService from 'NotificationService';
import $ from 'jquery';
import listService from 'ListService';

class ActionDetailsView extends View {

    initialize(opts) {

        this.options = opts || {};
        this.template = contentTemplate;
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        const ownerId = this.model.get("ownerId");                    
        const currentUserId = listService.accountSettings.UserId;

        const isOwner = ownerId === currentUserId;
        this.model.set("isOwner", isOwner, {silent:true});

        const actionService = new ActionService({model:this.model});

        const generalView = new ActionGeneralView({el:'#actionGeneral', model:this.model, actionService});
        const permissionsView = new PermissionsView({el:'#permissions', model:this.model, service: actionService, detailsName: 'currentActionDetails'});
        const detailView = DetailViewFactory.getActionDetailView(this.options.type, {el:'#actionDetails', model:this.model, actionService});
        const actionOperationsView = new ActionOperationsView({el: '#actionOperationsView', model:this.model, actionService});
        //const connectionHelpView = new ConnectionHelpView({el: '#connectionsHelp', model:this.model, actionService});

        generalView.render();
        permissionsView.render();
        detailView.render();
        actionOperationsView.render();
        //connectionHelpView.render();

        $('#goToConnections').on("click", this.goToConnections);
        $('#goToDatabases').on("click", this.goToConnectionDetail);

        this.checkForDisabledDetailView();
    }


    checkForDisabledDetailView(){
        let serviceType = this.model.get('unAllowedWebServiceType');
        if(serviceType){
            switch(serviceType){
                case 'salesforce':NotificationService.warning('The salesforce Web Service feature is not enabled on your account. Contact ' + listService.salesEmailAddress + ' for more information');break;
                case 'sap':NotificationService.warning('The salesforce Web Service feature is not enabled on your account. Contact ' + listService.salesEmailAddress + ' for more information');break;
            }

            $('#actionGeneral input, #actionGeneral button, #actionGeneral select').prop('disabled',true);
            $('#actionDetails input, #actionDetails button, #actionDetails select').prop('disabled',true);
            $('#actionOperationsView input, #actionOperationsView button, #actionOperationsView select').prop('disabled',true);
        }
    }

    goToConnections(e) {
        e.preventDefault();
        e.stopPropagation();

        eventBus.trigger("loadConnectionsView");
    }

    refresh(){
        if(this.model.get('hasChanges')){

            let simpleModal=new SimpleConfirmModalView({
                model:new Model({subtitle:`Connection - ${this.model.get("actionDetails").Name}`,
                    confirmationText:`Are you sure you want to refresh this page?\r All changes made on the current page will be lost.`,
                    height:200,
                    width:400})
            });
            simpleModal.render().then((result)=>{
                if (result === 'Ok') {
                    eventBus.trigger(constants.EV_REFRESH_ACTION_DETAILS,this.model.get('actionId'),this.model.get('connectionId'));
                }
            }).catch((err)=> {
                console.log('Error Showing Refresh Confirmation Message', err);
                NotificationService.error('Error Showing Refresh Confirmation Message' + err.MESSAGE);
            });
        }
        else{
            eventBus.trigger(constants.EV_REFRESH_ACTION_DETAILS,this.model.get('actionId'),this.model.get('connectionId'));
        }
    }

    goToConnectionDetail(e) {
        e.preventDefault();
        e.stopPropagation();

        let el = $(e.currentTarget).data('route');

        $("a.item-link[data-itemid='" + el + "']").click();
    }
}

export default ActionDetailsView;

